import { apiClient, API_BASE_URL } from './apiClient';

const BASE = `${API_BASE_URL}/api/inventory`;

export const inventoryAPI = {
  async getFormats() {
    return apiClient(`${BASE}/formats`);
  },

  async getCatalog(itemType = '') {
    const query = itemType ? `?item_type=${encodeURIComponent(itemType)}` : '';
    return apiClient(`${BASE}/catalog${query}`);
  },

  async getStock(kind) {
    return apiClient(`${BASE}/${kind}/stock`);
  },

  async getIngresos(kind) {
    return apiClient(`${BASE}/${kind}/ingresos`);
  },

  async getEgresos(kind) {
    return apiClient(`${BASE}/${kind}/egresos`);
  },

  async createProduct(data) {
    return apiClient(`${BASE}/products`, {
      method: 'POST',
      body: JSON.stringify(data),
    });
  },
};

export default inventoryAPI;
